import { createSlice } from "@reduxjs/toolkit";
import { fetchAssignedFileDetails } from "@store/thunks/translationThunk";

const translatorAdminSlice = createSlice({
  name: "translatorAdmin",
  initialState: {
    translatorAdminDetails: [],
    translators: [],
    assignedProjects: [],
    assignedFolders: {}, // Changed from array to object
    assignedFiles: {},  // Changed from array to object
    selectedAssignedProjectId: null,
    selectedAssignedFolderId: null,
    selectedAssignedFileId: null,
    selectedFile: {},
    assignedLanguages: [],
    assignedLanguagesToUser: [],
    assignedFileDetails: [],
    assignedFileDetailsLoading: false,
    sentenceTableData: [],
    fileStatus: null,
  },
  reducers: {
    addTranslatorAdminDetails: (state, action) => {
      state.translatorAdminDetails = action.payload;
    },
    addTranslators: (state, action) => {
      state.translators = action.payload;
    },
    addAssignedProjects: (state, action) => {
      state.assignedProjects = action.payload;
    },
    addAssignedFolders: (state, action) => {
      state.assignedFolders = {
        ...state.assignedFolders,
        [state.selectedAssignedProjectId]: action.payload, // Uses selectedAssignedProjectId
      };
    },
    addAssignedFiles: (state, action) => {
      state.assignedFiles = {
        ...state.assignedFiles,
        [state.selectedAssignedFolderId]: action.payload, // Uses selectedAssignedFolderId
      };
    },
    setSelectedAssignedProjectId: (state, action) => {
      state.selectedAssignedProjectId = action.payload;
    },
    setSelectedAssignedFolderId: (state, action) => {
      state.selectedAssignedFolderId = action.payload;
    },
    setSelectedAssignedFileId: (state, action) => {
      state.selectedAssignedFileId = action.payload;
    },
    setSelectedFile: (state, action) => {
      state.selectedFile = action.payload;
    },
    setSentenceTableData: (state, action) => {
      state.sentenceTableData = action.payload;
    },
    setFileStatus: (state, action) => {
      state.fileStatus = action.payload;
    },
    setAssignedLanguages: (state, action) => {
      state.assignedLanguages = action.payload;
    },
    setAssignedLanguagesToUser: (state, action) => {
      state.assignedLanguagesToUser = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAssignedFileDetails.pending, (state) => {
        state.assignedFileDetailsLoading = true;
      })
      .addCase(fetchAssignedFileDetails.fulfilled, (state, action) => {
        state.assignedFileDetailsLoading = false;
        state.assignedFileDetails = action.payload;
      })
      .addCase(fetchAssignedFileDetails.rejected, (state) => {
        state.assignedFileDetailsLoading = false;
        state.assignedFileDetails = {};
      });
  },
});

export const {
  addAssignedFiles,
  addAssignedFolders,
  addAssignedProjects,
  addTranslatorAdminDetails,
  addTranslators,
  setSelectedAssignedFileId,
  setSelectedAssignedFolderId,
  setSelectedAssignedProjectId,
  setSelectedFile,
  setSentenceTableData,
  setFileStatus,
  setAssignedLanguages,
  setAssignedLanguagesToUser,
} = translatorAdminSlice.actions;

export default translatorAdminSlice.reducer;